import { useState } from 'react';

import {
    Typography, Grid, Button, Input,
    InputAdornment, Box,
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { getTitle, normalizeString } from '../../../../helpers/admin/productHelper';

const ProductSelect = ({ text, setProduct, allProducts }) => {
    // lista de productos
    // const { products } = useSelector(state => state.product);
    const [products, setProducts] = useState([]);
    // búsqueda de producto
    const [search, setSearch] = useState('');

    // producto buscando
    const handleInputChange = ({ target }) => {
        setSearch(target.value);
        if (target.value !== '') filterProducts(target.value);
        else setProducts([]);
    };

    // filtrar productos por búsqueda
    const filterProducts = (value) => {
        if (value === '') {
            setProducts([]);
            return;
        }
        // primero filter y luego set
        if (allProducts.length > 0) {
            const _search = normalizeString(value);
            setProducts(allProducts.filter(({ title, variant_title, prod_category, keywords }) => {
                const _title = normalizeString(title);
                const _variant_title = normalizeString(variant_title);
                const categories = prod_category.map(({ url }) => url).join(" ");

                return (
                    _title.includes(_search) ||
                    _variant_title.includes(_search)
                    || (categories && categories.includes(_search))
                    || keywords.includes(_search)
                    || keywords.filter(e => e.indexOf(_search) >= 0).length > 0
                ) ? true : false;
            }));
        }
    };

    // seleccionar producto
    const selectProduct = _prod_var_id => () => {
        const item = products.find(e => e.prod_var_id === _prod_var_id);
        if (item) {
            const { prod_var_id, title, variant_title, price, img } = item;
            setProduct({
                variant_id: prod_var_id,
                title, variant_title, price,
                image_id: img.id
            });
            setSearch('');
            setProducts([]);
        }
    };
    
    return (
        <Box sx={{ my: 3 }}>
            {
                text &&
                    <Typography variant="subtitle1" gutterBottom>
                        {text}
                    </Typography>
            }
            <Input fullWidth sx={{ mb: 2 }}
                placeholder="Buscar producto (título/categoría)"
                value={search}
                onChange={handleInputChange}
                startAdornment={
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                }
            />
            <Grid container spacing={4}>
                {
                    products.map(({ prod_var_id, title, variant_title, price, img }) =>
                        <Grid item xl={4} lg={6} md={6} sm={12} key={prod_var_id}>
                            <Box sx={{
                                    display: 'flex', justifyContent: 'flex-start', gap: '15px', borderRadius: '5px',
                                    padding: '10px', boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)'
                                }}>
                                <Box sx={{ my: 'auto' }}>
                                    <img width='120' height="120"
                                        style={{ objectFit: 'contain' }}
                                        src={img.id} alt={img.alt}
                                    />
                                </Box>
                                <Box sx={{ my: 'auto' }}>
                                    <Typography component="div" variant="h6">
                                        { getTitle(title, variant_title) }
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary" component="div" gutterBottom>
                                        { `$${price}` }
                                    </Typography>
                                    <Button size="small" variant='outlined'
                                        onClick={selectProduct(prod_var_id)}>
                                        Seleccionar
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    )
                }
            </Grid>
        </Box>
    );
};

export default ProductSelect;